/**
 *
 * @param {object} trigger                   HTML node that is the trigger for loading more markup
 * @param {string | string[]} markup         markup that will replace HTML node.
 * @param {string} replaceWithMarkup         Query string for node that new posts will replace.
 * @param {boolean} reinitialize             Add the trigger's markup onto the replacing markup
 */
export default function replaceWithMarkup( trigger, markup, replaceWithMarkup, reinitialize = false) {

    if( 'undefined' !== typeof window.adw.posts.postsPerPage && window.adw.posts.postsPerPage > markup.length ){
        const replaceEl = document.querySelector( replaceWithMarkup );
        if ( replaceEl ) {
            replaceEl.innerHTML = '';
        }
    }
    if ( Array.isArray( markup ) ){
        markup = markup.join( '' );
    }

    let newMarkup = '';

    if ( markup ){
        // Get trigger HTML before it gets removed from DOM
        const triggerHTML = reinitialize && trigger ? trigger.outerHTML : '';
        newMarkup = reinitialize ? markup + triggerHTML : markup;
    }

    // Use jQuery replaceWith but ensure we're targeting the right element
    const $replaceEl = $( replaceWithMarkup );
    if ( $replaceEl.length ) {
        $replaceEl.replaceWith( newMarkup );
    }
    
    setTimeout(function() {
        if ( typeof triggerIntegratePremiumLock === 'function' ) {
            triggerIntegratePremiumLock();
        }
      }, 100);
    $('[data-bs-toggle="tooltip"]').tooltip();
}
